import styled from '@emotion/styled';
import { TopHeader } from 'ui/components/panes/Header/TopHeader';
import { TopFooter } from 'ui/components/panes/Footer/TopFooter';
import { mqMin, mqUser } from 'utils/responsive';
import { useNavigate } from 'react-router-dom';
import IssueImg01 from 'ui/images/top/topIssue_img01@2x.png';

const Wrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
`;

const MainContent = styled.main`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
`;

const ErrorCode = styled.h1`
    font-size: 8rem;
    font-weight: 800;
    color: #2d3748;
    margin: 0;

    ${mqMin('STANDARD')} {
        font-size: 12rem;
    }
`;

const ErrorMessage = styled.h2`
    font-size: 1.5rem;
    color: #4a5568;
    margin: 1rem 0;
    text-align: center;

    ${mqMin('STANDARD')} {
        font-size: 2rem;
    }
`;

const Description = styled.p`
    font-size: 1rem;
    color: #718096;
    text-align: center;
    max-width: 600px;
    margin-bottom: 2rem;
`;

const Flex = styled.div`
    display: flex;
    gap: 20px;
    align-items: center;
    position: relative;
`;

const Illustration = styled.img`
    width: 80px;
    height: auto;
    object-fit: contain;
    flex-shrink: 0;
    margin-top: auto;
    position: absolute;
    bottom: 0;
    right: -90px;

    ${mqUser('SP')} {
        display: none;
    }
`;

const HomeButton = styled.button`
    padding: 1rem 2rem;
    font-size: 1rem;
    color: white;
    background-color: #4299e1;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: #3182ce;
        transform: translateY(-2px);
        box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
    }
`;

export const NotFound: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Wrapper>
            <TopHeader />
            <MainContent>
                <Flex>
                    <ErrorCode>404</ErrorCode>
                    <Illustration src={IssueImg01} alt="404 illustration" />
                </Flex>
                <ErrorMessage>ページが見つかりません</ErrorMessage>
                <Description>
                    お探しのページは存在しないか、移動した可能性があります。
                    トップページに戻って、もう一度お試しください。
                </Description>
                <HomeButton onClick={() => navigate('/')}>トップに戻る</HomeButton>
            </MainContent>
            <TopFooter />
        </Wrapper>
    );
};
